import { render } from "./Buscador.vue?vue&type=template&id=f1fe1b0a"
import script from "./Buscador.vue?vue&type=script&lang=js"
export * from "./Buscador.vue?vue&type=script&lang=js"

import "./Buscador.vue?vue&type=style&index=0&id=f1fe1b0a&lang=scss"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__